<div class="location-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="location-header">
      <h2>📍 Ubicación</h2>
    </div>

    <div class="location-content">
    <!-- Permission Status -->
    <div class="card permission-status">
      <div [ngClass]="'status-card status-' + (permissionStatus.granted ? 'granted' : permissionStatus.denied ? 'denied' : 'prompt')">
        <div class="status-icon">
          <span *ngIf="permissionStatus.granted">✅</span>
          <span *ngIf="permissionStatus.denied">❌</span>
          <span *ngIf="permissionStatus.prompt">⚠️</span>
        </div>
        
        <div class="status-info">
          <h3 *ngIf="permissionStatus.granted">Permiso otorgado</h3>
          <h3 *ngIf="permissionStatus.denied">Permiso denegado</h3>
          <h3 *ngIf="permissionStatus.prompt">Permiso requerido</h3>
          
          <p *ngIf="permissionStatus.granted">Tienes acceso a tu ubicación</p>
          <p *ngIf="permissionStatus.denied">No se puede acceder a la ubicación</p>
          <p *ngIf="permissionStatus.prompt">Se necesita acceso a la ubicación</p>
          
          <p *ngIf="permissionStatus.error" class="error-text">
            {{ permissionStatus.error }}
          </p>
        </div>
      </div>
    </div>

    <!-- Request Permission Button -->
    <div *ngIf="!permissionStatus.granted" class="permission-actions">
      <button 
        (click)="requestPermission()" 
        [disabled]="loading"
        class="btn btn-primary btn-block btn-lg"
      >
        <span *ngIf="loading">⏳ Solicitando...</span>
        <span *ngIf="!loading">🔓 Solicitar Permiso de Ubicación</span>
      </button>
    </div>

    <!-- Location Actions -->
    <div *ngIf="permissionStatus.granted" class="location-actions">
      <button 
        (click)="getCurrentLocation()" 
        [disabled]="loading"
        class="btn btn-secondary btn-block btn-lg"
      >
        <span *ngIf="loading">⏳ Obteniendo...</span>
        <span *ngIf="!loading">📍 Obtener Ubicación Actual</span>
      </button>

      <button 
        (click)="toggleWatchLocation()" 
        [disabled]="loading"
        [ngClass]="watching ? 'btn btn-danger btn-block btn-lg' : 'btn btn-success btn-block btn-lg'"
      >
        <span *ngIf="watching">🔴 Detener Seguimiento</span>
        <span *ngIf="!watching">🔵 Iniciar Seguimiento</span>
      </button>
    </div>

    <!-- Location Display -->
    <div *ngIf="position" class="location-display">
      <div class="card location-card">
        <div class="location-info">
          <h3>🗺️ Tu Ubicación</h3>
          
          <div class="location-details">
            <div class="detail-row">
              <strong>Latitud:</strong>
              <span>{{ position.latitude | number:'1.6-6' }}</span>
            </div>
            
            <div class="detail-row">
              <strong>Longitud:</strong>
              <span>{{ position.longitude | number:'1.6-6' }}</span>
            </div>
            
            <div class="detail-row">
              <strong>Precisión:</strong>
              <span>{{ position.accuracy | number:'1.0-0' }} metros</span>
            </div>
            
            <div class="detail-row">
              <strong>Última actualización:</strong>
              <span>{{ formatTimestamp(position.timestamp) }}</span>
            </div>
          </div>

          <div class="location-coordinates">
            <div class="coordinates-text">
              {{ position.latitude | number:'1.6-6' }}, {{ position.longitude | number:'1.6-6' }}
            </div>
            
            <button 
              (click)="copyCoordinates()" 
              class="btn-copy"
              title="Copiar coordenadas"
            >
              📋
            </button>
          </div>
        </div>

        <div class="location-actions-inline">
          <a 
            [href]="getLocationUrl()" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn-map"
          >
            🗺️ Ver en Google Maps
          </a>
          
          <button 
            (click)="shareLocation()" 
            class="btn-share"
            *ngIf="canShare()"
          >
            📤 Compartir
          </button>
        </div>
      </div>
    </div>

    <!-- Watching Status -->
    <div *ngIf="watching" class="watching-status">
      <div class="status-indicator">
        <div class="pulse"></div>
        <span>📡 Rastreando ubicación en tiempo real...</span>
      </div>
    </div>

    <!-- No Location Message -->
    <div *ngIf="permissionStatus.granted && !position && !loading" class="no-location">
      <div class="message-content">
        <h3>📍 Sin ubicación</h3>
        <p>Haz clic en "Obtener Ubicación Actual" para ver tu posición.</p>
      </div>
    </div>
  </div>
</div>
